
import { useNavigate, useLocation } from 'react-router-dom';

export default function PreviewSiteButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Não mostrar o botão se já estiver na página de preview
  if (location.pathname === '/admin/preview-site') {
    return null;
  }

  // Só mostrar em rotas admin
  if (!location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <button
      onClick={() => navigate('/admin/preview-site')}
      className="fixed bottom-28 right-8 z-50 flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full shadow-2xl hover:shadow-amber-500/50 hover:scale-105 transition-all duration-300 font-semibold text-lg group"
      aria-label="Preview do Site"
    >
      <i className="ri-eye-line text-2xl group-hover:scale-110 transition-transform"></i>
      <span>Preview do Site</span>
    </button>
  );
}
